<div class="billing-page">
    <sync-spinner *ngIf="isLoading"></sync-spinner>

    <ng-container *ngIf="!isLoading">
        <div class="plan-container">
            <div class="section-header">{{planName}}</div>

            <div class="plan-section">
                <div *ngIf="isPlanLoading" class="plan-spinner-wrapper">
                    <sync-spinner></sync-spinner>
                </div>
                <ng-container *ngIf="!isPlanLoading">
                    <div class="plan-flexbox">
                        <div class="doughnut-chart" *ngIf="!user.is_unlimited_plan">
                            <canvas baseChart [labels]="doughnutChartLabels" [datasets]="doughnutChartDatasets"
                                [options]="doughnutChartOptions" [legend]="false" type="doughnut">
                            </canvas>
                        </div>
                        <div class="doughnut-chart" *ngIf="user.is_unlimited_plan">
                            <img src="assets/icons/infinity.svg">
                        </div>
                        <div class="plan-details">
                            <div>
                                <div class="overline">STORAGE SPACE USED</div>
                                <div class="h4">
                                  <span [ngClass]="usageType">{{du.bytes | bytesToSize}}</span> /
                                  {{user.is_unlimited_plan ? 'Unlimited' : (du.limit_bytes | bytesToSize)}}
                                </div>
                            </div>
                            <div class="chart-legend">
                                <div class="chart-legend-sync">
                                    <div class="legend-color" [style.background]="chartColors[1]"></div>
                                    <div class="legend-text caption">Files</div>
                                    <div class="legend-size caption">{{du.sync_bytes | bytesToSize}}</div>
                                </div>
                                <div class="chart-legend-vault">
                                    <div class="legend-color" [style.background]="chartColors[0]"></div>
                                    <div class="legend-text caption">Vault</div>
                                    <div class="legend-size caption">{{du.vault_bytes | bytesToSize}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="renewal-licenses-upgrade">
                        <div class="renewal-licenses">
                            <div class="renewal-details" *ngIf="subscriptionEndDate && !cancelInFuture">
                                <div *ngIf="!user.is_on_trial">
                                    <div class="overline">SUBSCRIPTION NEXT <br> RENEWAL DATE</div>
                                    <div class="h4">{{subscriptionEndDate}}</div>
                                </div>
                                <div *ngIf="user.is_on_trial">
                                    <div class="overline">TRIAL END DATE</div>
                                    <div class="h4">{{planExpiry | date: 'MMMM d, yyyy'}}</div>
                                    <a *ngIf="canManageBilling" class="body-2-link add-licences" routerLink="/settings/upgrade-plan" [queryParams]="{ trial: true }">Pay now</a>
                                </div>        
                            </div>
                            <div class="license-details" *ngIf="showPurchaseUsersOption && limit">
                                <div>
                                    <div class="overline">Users</div>
                                    <div class="h4">{{totalUsers}} / {{limit}}</div>
                                    <a *ngIf="canPurchaseUsers" class="body-2-link add-licences" routerLink="/settings/upgrade-plan">Purchase more users</a>
                                </div>
                            </div>
                        </div>
                        <div class="upgrade" *ngIf="canManageBilling">
                            <sync-button type="filled" [color]="buttonColor" label="Manage subscription"  [size]="'medium'"
                                (click)="onUpgradePlan()"></sync-button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="body-1 billing-not-allowed" *ngIf="!userService.checkPermission(permissionActions.VIEW_BILLING) && user.is_pro && user.is_multi_child">
            Please contact your administrator for billing inquiries.
        </div>
    </ng-container>
</div>

<div class="dialogBody">
    <sync-dialog [config]="{
      title: 'Edit auto renew settings',
      isClosable: false,
      actionButton: 'Save',
      cancelButton: 'Cancel',
      onActionClick: saveAutoRenew,
      onCancelClick: onCancelAutoRenewDialog,
      isButtonLoading: isAutoRenewLoading,
    }" [open]="isAutoRenewDialogOpen" [onClose]="onCancelAutoRenewDialog">

        <div class="body-2">
            Ensure you have continued access to your files by enabling automatic renewal of your Sync.com subscription.
        </div>
        <div class="auto-renew-container">

            <sync-switch size="large" label="Enable auto renew" labelPosition="before" [checked]="autoRenew"
                [onChange]="toggleRenewSwitch"></sync-switch>
        </div>
    </sync-dialog>
</div>
